<div
  class="flex flex-col grow content-center items-center bg-transparent"
  style="position: relative; width: 110px; height: 100px"
>
  <p-progress-spinner
    strokeWidth="4px"
    animationDuration=".7s"
    fill="none"
    [style]="{
      width: '100px',
      height: '100px',
      position: 'absolute',
      top: '0',
      left: '10px',
      stroke: 'var(--primary-color)'
    }"
  />
  <!-- 
    styleClass="custom-spinner" 
    -->
  <div class="grow justify-self-center self-center place-self-center">
    <s-ui-view-formatted-text class="bg-transparent" style="z-index: 999" [value]="dialogConfig.data | async" />
  </div>
</div>
